import React from 'react'
import { Layout } from '../layouts/Layout';
import { RilisAplikasi } from '../componen/rilis/RilisAplikasi'

export const RilisAplikasiPages = () => {
  return (
    <Layout>
      <RilisAplikasi />
    </Layout>
  )
}
